__turbopack_context__.v({
  "btnWrapper": "page-module__-gJYpq__btnWrapper",
  "checkboxWrapper": "page-module__-gJYpq__checkboxWrapper",
  "contentWrapper": "page-module__-gJYpq__contentWrapper",
  "disclaimer": "page-module__-gJYpq__disclaimer",
  "fields": "page-module__-gJYpq__fields",
  "forgotPasswordLink": "page-module__-gJYpq__forgotPasswordLink",
  "form": "page-module__-gJYpq__form",
  "info": "page-module__-gJYpq__info",
  "loginDisclaimer": "page-module__-gJYpq__loginDisclaimer",
  "nextBtn": "page-module__-gJYpq__nextBtn",
  "passwordIcon": "page-module__-gJYpq__passwordIcon",
  "requiredText": "page-module__-gJYpq__requiredText",
  "signUpWrapper": "page-module__-gJYpq__signUpWrapper",
  "title": "page-module__-gJYpq__title",
  "titleWrapper": "page-module__-gJYpq__titleWrapper",
});
